import script from "./BasePaymentCondition.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasePaymentCondition.vue?vue&type=script&lang=ts&setup=true"

import "./BasePaymentCondition.vue?vue&type=style&index=0&id=5707b439&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5707b439"]])

export default __exports__